import * as xstateModel from 'xstate/lib/model'

const createModel = xstateModel.createModel

export const createAvatarCroppingMachine = () => {
  const model = createModel(
    {
      file: undefined as File | undefined,
      croppedFile: undefined as File | undefined,
      error: undefined as string | undefined,
      uploadProgress: 0,
    },
    {
      events: {
        selectFile: () => ({}),
        fileSelected: (file: File) => ({ value: file }),
        save: () => ({}),
        success: () => ({}),
        cancel: () => ({}),
        uploadProgress: (progress: ProgressEvent) => ({ value: progress }),
        serviceError: () => ({}),
      },
    },
  )

  const assignFile = model.assign(
    { file: (_context, event) => event.value },
    'fileSelected',
  )

  const assignCroppedFile = model.assign(
    { croppedFile: (_context, event) => event.value },
    'fileSelected',
  )
  const assignUploadProgress = model.assign(
    {
      uploadProgress: (_context, { value: { loaded, total } }) =>
        Math.round((loaded / total) * 100),
    },
    'uploadProgress',
  )

  return model.createMachine({
    id: 'upload-modal',
    initial: 'idle',
    context: model.initialContext,
    states: {
      idle: {
        on: {
          fileSelected: {
            target: 'cropping',
            actions: assignFile,
          },
        },
      },
      cropping: {
        on: {
          cancel: 'idle',
          save: 'saving',
          fileSelected: {
            actions: assignCroppedFile,
          },
        },
      },
      saving: {
        on: {
          uploadProgress: { actions: assignUploadProgress },
          success: { target: 'success' },
          serviceError: 'error',
        },
        invoke: {
          id: 'save-photo',
          src: 'onSave',
        },
      },
      success: {
        type: 'final',
        entry: ['onSuccess'],
      },
      error: {},
    },
  })
}
